module.exports = __webpack_public_path__ + "static/media/menuGear.b131572a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuGear.svg
// module id = 469
// module chunks = 0